import { render, staticRenderFns } from "./MoviePoster.vue?vue&type=template&id=62f6cc92&scoped=true&"
import script from "./MoviePoster.vue?vue&type=script&lang=js&"
export * from "./MoviePoster.vue?vue&type=script&lang=js&"
import style0 from "./MoviePoster.vue?vue&type=style&index=0&id=62f6cc92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f6cc92",
  null
  
)

export default component.exports